import React from 'react'
import { EmarModuleCard, FamilyPlanModuleCard } from '@lmc/ui-kit'
import { PaywallTemplateWrapper } from '../../../../../components/generic/PaywallTemplateWrapper'
import { colors } from '@lmc/common/constants'
import { IconType } from '@lmc/ui-kit'
import { colours } from '@lmc/ui-kit/src/config/theme'

interface StateProps {
  testId?: string
}

const DocumentsPaywallComponent: React.FC<StateProps> = ({ testId }) => {
  return (
    <PaywallTemplateWrapper
      backgroundColor={colours.status.popout}
      title="Policies and Procedures"
      subTitle="Safely store all your important documents, policies, and procedures in one centralised library. You’ll have unlimited storage and consistent operations across the service."
      bodyText="Improve communication and efficiency."
      icon={IconType.DocsHexagon}
      videoUrl="https://www.youtube.com/embed/2XCgAbKwzvQ"
      testId={testId}
      articles={[
        {
          title: 'How do I upload my policies?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/articles/2885531-how-do-i-upload-my-policies-and-procedures',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white
        },
        {
          title: 'How much does it cost?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/collections/794841-faqs',
          iconBackgroundColour: colors.green,
          iconColour: colors.white
        },
        {
          title: 'What other features do I get with Pro?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white
        }
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      findOutMoreURL="https://logmycare.co.uk/features/service-efficiency#docs"
      customLinkText="Read more"
    />
  )
}

export const DocumentsPaywall = DocumentsPaywallComponent
